import { BackToOptionsLink } from '../../components/BackToOptionsLink';
import { SignUpCard } from '../SignUpCard';
import { UnauthedPageWithNavbar } from '../../../layout/UnauthedPageWithNavbar';
import CorporateVolunteer from './corporate-volunteer.svg';
import IndividualVolunteer from './individual-volunteer.svg';
import { ROUTES } from '../../../routes/consts';

export const VolunteerSelectionPage = () => {
  return (
    <UnauthedPageWithNavbar>
      <div className='md:w-full flex flex-col items-center mt-[20px] md:mt-[100px] gap-10 l px-4'>
        <h3 className='text-center text-display-md font-medium text-gray-700'>
          What kind of volunteer are you?
        </h3>
        <div className='flex flex-col md:flex-row gap-[48px]'>
          <SignUpCard
            img={CorporateVolunteer}
            header='Corporate Volunteer'
            description="I've been sponsored by my employer for a program"
            url={ROUTES.SIGN_UP_PRO_CORPORATE}
          />
          <SignUpCard
            img={IndividualVolunteer}
            header='Individual Volunteer'
            description="I'm a professional volunteering on my own"
            url={ROUTES.SIGN_UP_PRO_INDIVIDUAL}
          />
        </div>
        <div>
          Not sure which one you are?{' '}
          <a
            className='text-brand-500 underline'
            href='https://zsupport.movingworlds.org/portal/en/kb/articles/why-can-t-i-log-in-to-my-account'
          >
            Learn more
          </a>
        </div>
        <BackToOptionsLink url={`~/platform${ROUTES.AUTH}${ROUTES.SIGN_UP}`} />
      </div>
    </UnauthedPageWithNavbar>
  );
};
